import { render, staticRenderFns } from "./orderDetails.vue?vue&type=template&id=45c78c73&scoped=true"
import script from "./orderDetails.vue?vue&type=script&lang=js"
export * from "./orderDetails.vue?vue&type=script&lang=js"
import style0 from "./orderDetails.vue?vue&type=style&index=0&id=45c78c73&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c78c73",
  null
  
)

export default component.exports